<template>
  <el-dialog
    :visible="visible"
    width="85%"
    top="5vh"
    append-to-body
    destroy-on-close
    @update:visible="(val) => $emit('update:visible', val)"
  >
    <div slot="title" class="merged-preview__title">
      Xem trước bài giao
      <small>{{ items.length }} đề · {{ totalQuestions }} câu hỏi · theo thứ tự trong bài giao</small>
    </div>

    <div class="merged-preview" v-loading="loading">
      <section v-for="(exam, i) in exams" :key="exam._id" class="merged-preview__section">
        <h4 class="merged-preview__heading">
          <span class="merged-preview__index">{{ i + 1 }}</span>
          {{ exam.title }}
        </h4>
        <ExamPreviewContent :exam="exam" />
      </section>
    </div>
  </el-dialog>
</template>

<script>
import examVaultService from '@/api/exam-vault'
import ExamPreviewContent from './ExamPreviewContent.vue'

export default {
  name: 'MergedPreviewDialog',
  components: { ExamPreviewContent },

  props: {
    visible: { type: Boolean, default: false },
    // Thứ tự = thứ tự gộp trong bài giao
    items: { type: Array, default: () => [] }
  },

  data() {
    return {
      exams: [],
      loading: false
    }
  },

  computed: {
    totalQuestions() {
      return this.exams.reduce((sum, exam) => sum + (exam.questionCount || 0), 0)
    }
  },

  watch: {
    visible(value) {
      if (value) this.fetchExams()
    }
  },

  methods: {
    async fetchExams() {
      this.exams = []
      this.loading = true
      try {
        const results = await Promise.all(this.items.map((item) => examVaultService.getExamById(item._id)))
        this.exams = results.map((res) => res.data.exam)
      } catch (error) {
        console.error('Failed to preview exams', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.merged-preview {
  min-height: 200px;

  &__title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 18px;
    font-weight: 700;
    color: #111827;

    small {
      color: #6b7280;
      font-size: 13px;
      font-weight: 400;
    }
  }

  &__section + &__section {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px dashed #e5e7eb;
  }

  &__heading {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 12px;
    color: #111827;
    font-size: 16px;
  }

  &__index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #1cab36;
    color: #fff;
    font-size: 13px;
  }
}
</style>
